const image = {
  selectArrow: '/assets/images/common/ic-select.png',
  placeholderImg: '/assets/images/common/ic-placeholder-img.png',
  searchBtn: '/assets/components/CSearch/ic-csearch-btn.png',
  logo: '/assets/images/common/ic-logo.png',
};

export default image;
